import { route } from 'quasar/wrappers';
import { createMemoryHistory, createRouter, createWebHashHistory, createWebHistory } from 'vue-router';

import routes from './routes';
import { LocalStorage } from 'quasar';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */
export const userAccessiblePages = ['complete-order-from-basket'];

export const userPages = routes
  .filter((route) => ['user'].includes(route.name as string))
  .flatMap((route) => route.children ?? []) // children undefined ise boş dizi kullan
  .map((child) => child.name) as string[];

export const pagesInSafe = userAccessiblePages.concat(userPages);

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER ? createMemoryHistory : process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  Router.beforeEach((to, from, next) => {
    const token = LocalStorage.getItem('user-token');

    if (!token && userPages.includes(to.name as string) && !import.meta.env.SSR) {
      next('/login-or-register');
    } else if (!token && to.name === 'complete-order') {
      next('login');
    } else {
      next();
    }
  });

  return Router;
});
